import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CreateNewCVPCandidateParametersSimple } from "./CreateNewCVPCandidateParametersSimple";

export interface CreateProfileParameterSuggestionResponse
  extends BackendResponse,
    CreateNewCVPCandidateParametersSimple {}

export interface CreateProfileParameterSuggestionParameters
  extends NextApiParams {}

export const createProfileParameterSuggestion = withNextApi<
  CreateProfileParameterSuggestionResponse,
  CreateProfileParameterSuggestionParameters
>("/auth/CreateProfileParameterSuggestion", { method: "GET" });
